import request from '@/utils/request'

export const getOrderList = ({ page, size, keywords: orderCode }) => {
  return request({
    url: `/trace/order/${page}/${size}`,
    params: {
      orderCode
    }
  })
}

export const postOrderEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/order',
    data
  })
}

export const putOrderAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/order',
    data
  })
}

export const getOrderDetail = (id) => {
  return request({
    url: `/trace/order/${id}`
  })
}

export const deleteOrderDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/order/${id}`
  })
}

export const delOrderList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/order/all',
    data
  })
}

// 订单明细信息
export const getOrderInfoList = ({ page, size, keywords: productName, orderId }) => {
  return request({
    url: `/trace/order/info/${page}/${size}`,
    params: {
      productName,
      orderId
    }
  })
}

export const postOrderInfoEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/order/info',
    data
  })
}

export const putOrderInfoAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/order/info',
    data
  })
}

export const getOrderInfoDetail = (id) => {
  return request({
    url: `/trace/order/info/${id}`
  })
}

export const deleteOrderInfoDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/order/info/${id}`
  })
}

export const delOrderInfoList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/order/info/all',
    data
  })
}
